import React, { useState } from 'react';
import { CarIcon, TruckIcon, WrenchIcon, ChevronDownIcon, ChevronUpIcon, CheckCircleIcon, ClipboardListIcon, PhoneIcon } from 'lucide-react';
export function Services() {
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({});
  const toggleSection = (key: string) => {
    setExpandedSections(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };
  return <section id="services" className="py-20 bg-white" data-id="element-8390">
      <div className="container mx-auto px-4" data-id="element-8391">
        <div className="max-w-6xl mx-auto" data-id="element-8392">
          <h2 className="text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-8393">
            Auto & Truck Repair Services
          </h2>
          <p className="text-xl text-gray-600 text-center mb-16 max-w-3xl mx-auto" data-id="element-8394">
            Expert diagnostic, repair, and maintenance services for all makes
            and models. From passenger vehicles to heavy-duty commercial trucks.
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-8395">
            {/* Automotive Services */}
            <div className="group relative overflow-hidden rounded-lg shadow-lg border-2 border-black hover:shadow-2xl transition-all duration-300" data-id="element-8396">
              <div className="relative h-64 overflow-hidden" data-id="element-8397">
                <img src="https://cdn.magicpatterns.com/uploads/9yVbX3hih4MeQMJVSjZRxG/Automotice-Services.png" alt="Automotive repair services" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-8398" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-8399"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-8400">
                  <div className="flex items-center mb-2" data-id="element-8401">
                    <div className="bg-[#B1050B] p-2 rounded mr-3" data-id="element-8402">
                      <CarIcon size={28} className="text-white" data-id="element-8403" />
                    </div>
                    <h3 className="text-2xl font-bold text-white" data-id="element-8404">
                      Automotive Services
                    </h3>
                  </div>
                  <p className="text-gray-200 text-sm" data-id="element-8405">
                    Complete repair and maintenance for cars, SUVs, and light
                    trucks
                  </p>
                </div>
              </div>

              <div className="bg-white p-6" data-id="element-8406">
                <p className="text-gray-700 mb-4" data-id="element-8407">
                  Expert mechanics providing comprehensive service, maintenance,
                  diagnostics, and repair for all makes and models of passenger
                  vehicles, SUVs, and light-duty trucks. From routine oil
                  changes to complex engine rebuilds.
                </p>

                <button onClick={() => toggleSection('automotive')} className="flex items-center text-[#B1050B] hover:text-[#8A0408] font-medium transition-colors" data-id="element-8408">
                  {expandedSections['automotive'] ? <>
                      <ChevronUpIcon size={20} className="mr-1" data-id="element-8409" />
                      Show Less
                    </> : <>
                      <ChevronDownIcon size={20} className="mr-1" data-id="element-8410" />
                      View All Services
                    </>}
                </button>

                {expandedSections['automotive'] && <div className="mt-6 pt-6 border-t-2 border-gray-200" data-id="element-8411">
                    <div className="grid sm:grid-cols-2 gap-4" data-id="element-8412">
                      <div data-id="element-8413">
                        <ul className="space-y-2 text-gray-700" data-id="element-8414">
                          <li data-id="element-8415">• Complete diagnostic services</li>
                          <li data-id="element-8416">• Brake service and repair</li>
                          <li data-id="element-8417">• Engine repair and rebuilding</li>
                          <li data-id="element-8418">• Transmission service</li>
                          <li data-id="element-8419">• Suspension and steering</li>
                          <li data-id="element-8420">• Electrical system diagnosis</li>
                          <li data-id="element-8421">• Air conditioning service</li>
                          <li data-id="element-8422">• Heating system repair</li>
                        </ul>
                      </div>
                      <div data-id="element-8423">
                        <ul className="space-y-2 text-gray-700" data-id="element-8424">
                          <li data-id="element-8425">• Oil changes and fluid services</li>
                          <li data-id="element-8426">• Tire service and alignment</li>
                          <li data-id="element-8427">• Battery testing and replacement</li>
                          <li data-id="element-8428">• Exhaust system repair</li>
                          <li data-id="element-8429">• Cooling system service</li>
                          <li data-id="element-8430">• Fuel system service</li>
                          <li data-id="element-8431">• Preventive maintenance</li>
                          <li data-id="element-8432">• State inspections</li>
                        </ul>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>

            {/* Commercial Truck Services */}
            <div className="group relative overflow-hidden rounded-lg shadow-lg border-2 border-black hover:shadow-2xl transition-all duration-300" data-id="element-8433">
              <div className="relative h-64 overflow-hidden" data-id="element-8434">
                <img src="https://cdn.magicpatterns.com/uploads/rfsCx6R5bBDAChYmGNqFwk/CommercialTruckServices.png" alt="Commercial truck repair services" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-8435" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-8436"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-8437">
                  <div className="flex items-center mb-2" data-id="element-8438">
                    <div className="bg-[#B1050B] p-2 rounded mr-3" data-id="element-8439">
                      <TruckIcon size={28} className="text-white" data-id="element-8440" />
                    </div>
                    <h3 className="text-2xl font-bold text-white" data-id="element-8441">
                      Commercial Truck Services
                    </h3>
                  </div>
                  <p className="text-gray-200 text-sm" data-id="element-8442">
                    Specialized service for medium and heavy-duty commercial
                    vehicles
                  </p>
                </div>
              </div>

              <div className="bg-white p-6" data-id="element-8443">
                <p className="text-gray-700 mb-4" data-id="element-8444">
                  Comprehensive commercial truck repair and maintenance
                  specialists. We service all medium and heavy-duty commercial
                  vehicles, from routine maintenance to complete diagnostic and
                  repair services. Diesel and gas-powered vehicles.
                </p>

                <button onClick={() => toggleSection('commercial')} className="flex items-center text-[#B1050B] hover:text-[#8A0408] font-medium transition-colors" data-id="element-8445">
                  {expandedSections['commercial'] ? <>
                      <ChevronUpIcon size={20} className="mr-1" data-id="element-8446" />
                      Show Less
                    </> : <>
                      <ChevronDownIcon size={20} className="mr-1" data-id="element-8447" />
                      View All Services
                    </>}
                </button>

                {expandedSections['commercial'] && <div className="mt-6 pt-6 border-t-2 border-gray-200" data-id="element-8448">
                    <p className="text-gray-700 mb-4" data-id="element-8449">
                      Garrett Auto & Truck Service is well known in Southeast
                      Michigan for commercial truck service. Our master
                      mechanics keep your commercial fleet rolling with expert
                      maintenance and repair.
                    </p>
                    <div className="bg-black text-white p-4 rounded border-l-4 border-[#B1050B]" data-id="element-8450">
                      <p className="font-bold text-[#B1050B] mb-2" data-id="element-8451">
                        Commercial Fleet Care Services
                      </p>
                      <p className="text-white" data-id="element-8452">
                        Specialized maintenance programs for commercial fleets.
                        Call now to get scheduled for comprehensive fleet
                        maintenance and repair.
                      </p>
                    </div>
                  </div>}
              </div>
            </div>
          </div>

          {/* Fleet Maintenance Program - Expanded Full Width */}
          <div className="bg-white rounded-lg shadow-2xl overflow-hidden border-2 border-black" data-id="element-8453">
            <div className="grid lg:grid-cols-5 gap-0" data-id="element-8454">
              <div className="lg:col-span-2 relative h-96 lg:h-auto" data-id="element-8455">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/diQWqXykJ7zyqrF7FJPm6g/Commercial-Trucks.png" alt="Commercial work truck fleet in urban setting" className="w-full h-full object-cover" data-id="element-8456" />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gray-900/30 to-gray-900" data-id="element-8457"></div>
              </div>

              <div className="lg:col-span-3 p-8 lg:p-10 text-gray-900" data-id="element-8458">
                <div className="flex items-center mb-6" data-id="element-8459">
                  <div className="bg-[#B1050B] p-3 rounded-lg mr-4" data-id="element-8460">
                    <WrenchIcon size={36} className="text-white" data-id="element-8461" />
                  </div>
                  <div data-id="element-8462">
                    <h3 className="text-3xl font-bold mb-1" data-id="element-8463">
                      Fleet Maintenance Program
                    </h3>
                    <p className="text-[#B1050B] font-medium" data-id="element-8464">
                      For Commercial Work Trucks & Vehicles
                    </p>
                  </div>
                </div>

                <div className="space-y-4 mb-6" data-id="element-8465">
                  <p className="text-gray-700 text-lg leading-relaxed" data-id="element-8466">
                    Many truck and fleet owners postpone simple maintenance
                    procedures because taking vehicles to a service center eats
                    up valuable man-hours. The drop-off, pickup, and retrieval
                    process costs time and productivity.
                  </p>

                  <p className="text-gray-700 text-lg leading-relaxed" data-id="element-8467">
                    <strong className="text-gray-900" data-id="element-8468">The real cost?</strong>{' '}
                    Ignoring scheduled maintenance leads to breakdowns on the
                    side of the road, extended downtime, and problems that could
                    have been prevented. We eliminate these hassles with our
                    comprehensive fleet program.
                  </p>
                </div>

                <button onClick={() => toggleSection('fleet')} className="flex items-center text-[#B1050B] hover:text-[#8A0408] font-bold text-lg transition-colors mb-6" data-id="element-8469">
                  {expandedSections['fleet'] ? <>
                      <ChevronUpIcon size={24} className="mr-2" data-id="element-8470" />
                      Show Less Details
                    </> : <>
                      <ChevronDownIcon size={24} className="mr-2" data-id="element-8471" />
                      See How We Take the Hassle Out of Maintenance
                    </>}
                </button>

                {expandedSections['fleet'] && <div className="space-y-6" data-id="element-8472">
                    {/* How It Works */}
                    <div className="bg-gray-50 p-6 rounded-lg border-2 border-gray-200" data-id="element-8473">
                      <h4 className="font-bold text-2xl text-[#B1050B] mb-4 flex items-center" data-id="element-8474">
                        <ClipboardListIcon size={24} className="mr-2" data-id="element-8475" />
                        How Our Fleet Program Works
                      </h4>
                      <div className="grid sm:grid-cols-2 gap-4" data-id="element-8476">
                        <div className="flex items-start space-x-3" data-id="element-8477">
                          <CheckCircleIcon size={20} className="text-[#B1050B] flex-shrink-0 mt-1" data-id="element-8478" />
                          <p className="text-gray-700 leading-relaxed" data-id="element-8479">
                            We maintain your service records and D.O.T.
                            recordkeeping requirements in our state-of-the-art
                            database
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-8480">
                          <CheckCircleIcon size={20} className="text-[#B1050B] flex-shrink-0 mt-1" data-id="element-8481" />
                          <p className="text-gray-700 leading-relaxed" data-id="element-8482">
                            When it's time for service, we'll notify you in
                            advance
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-8483">
                          <CheckCircleIcon size={20} className="text-[#B1050B] flex-shrink-0 mt-1" data-id="element-8484" />
                          <p className="text-gray-700 leading-relaxed" data-id="element-8485">
                            Convenient scheduling to minimize downtime
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-8486">
                          <CheckCircleIcon size={20} className="text-[#B1050B] flex-shrink-0 mt-1" data-id="element-8487" />
                          <p className="text-gray-700 leading-relaxed" data-id="element-8488">
                            We inform you of any safety or reliability concerns
                            upfront
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-8489">
                          <CheckCircleIcon size={20} className="text-[#B1050B] flex-shrink-0 mt-1" data-id="element-8490" />
                          <p className="text-gray-700 leading-relaxed" data-id="element-8491">
                            You'll know exactly how long the vehicle will be out
                            of service
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-8492">
                          <CheckCircleIcon size={20} className="text-[#B1050B] flex-shrink-0 mt-1" data-id="element-8493" />
                          <p className="text-gray-700 leading-relaxed" data-id="element-8494">
                            Professional service to keep your fleet running
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Services Included */}
                    <div className="bg-gray-50 p-6 rounded-lg border-2 border-gray-200" data-id="element-8495">
                      <h4 className="font-bold text-xl text-gray-900 mb-4" data-id="element-8496">
                        Fleet Maintenance Services Include:
                      </h4>
                      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-8497">
                        <div className="text-gray-700" data-id="element-8498">
                          • Oil & filter changes
                        </div>
                        <div className="text-gray-700" data-id="element-8499">
                          • Chassis lubrication
                        </div>
                        <div className="text-gray-700" data-id="element-8500">
                          • Transmission service
                        </div>
                        <div className="text-gray-700" data-id="element-8501">• Brake adjustments</div>
                        <div className="text-gray-700" data-id="element-8502">• Wheel alignment</div>
                        <div className="text-gray-700" data-id="element-8503">
                          • Cooling system maintenance
                        </div>
                        <div className="text-gray-700" data-id="element-8504">
                          • Fuel injection service
                        </div>
                        <div className="text-gray-700" data-id="element-8505">
                          • Belt & hose replacement
                        </div>
                        <div className="text-gray-700" data-id="element-8506">
                          • Clutch adjustments
                        </div>
                        <div className="text-gray-700" data-id="element-8507">
                          • Preventive diagnostics
                        </div>
                        <div className="text-gray-700" data-id="element-8508">• DOT compliance</div>
                        <div className="text-gray-700" data-id="element-8509">• And much more</div>
                      </div>
                    </div>

                    {/* Value Proposition */}
                    <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#B1050B]" data-id="element-8510">
                      <p className="text-gray-700 text-lg leading-relaxed" data-id="element-8511">
                        <strong className="text-[#B1050B]" data-id="element-8512">
                          Garrett Auto & Truck believes in preventative
                          maintenance.
                        </strong>{' '}
                        We'll help you save time and money by providing the
                        diagnostic, repair, and replacement services recommended
                        by your vehicle manufacturer. Keep your commercial fleet
                        running reliably and avoid costly breakdowns.
                      </p>
                    </div>

                    {/* CTA */}
                    <div className="text-center pt-4" data-id="element-8513">
                      <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] text-white hover:bg-[#8A0408] px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-8514">
                        <PhoneIcon size={22} className="mr-2" data-id="element-8515" />
                        Call (248) 478-8382 for Fleet Service
                      </a>
                    </div>
                  </div>}

                {!expandedSections['fleet'] && <div data-id="element-8516">
                    <div className="grid sm:grid-cols-3 gap-4 mt-6" data-id="element-8517">
                      <div className="text-center p-4 bg-gray-50 rounded-lg border-2 border-gray-200" data-id="element-8518">
                        <div className="text-3xl font-bold text-[#B1050B] mb-1" data-id="element-8519">
                          Easy
                        </div>
                        <div className="text-sm text-gray-600" data-id="element-8520">Scheduling</div>
                      </div>
                      <div className="text-center p-4 bg-gray-50 rounded-lg border-2 border-gray-200" data-id="element-8521">
                        <div className="text-3xl font-bold text-[#B1050B] mb-1" data-id="element-8522">
                          DOT
                        </div>
                        <div className="text-sm text-gray-600" data-id="element-8523">
                          Record Keeping
                        </div>
                      </div>
                      <div className="text-center p-4 bg-gray-50 rounded-lg border-2 border-gray-200" data-id="element-8524">
                        <div className="text-3xl font-bold text-[#B1050B] mb-1" data-id="element-8525">
                          24/7
                        </div>
                        <div className="text-sm text-gray-600" data-id="element-8526">
                          Service Tracking
                        </div>
                      </div>
                    </div>

                    <div className="text-center mt-6" data-id="element-8527">
                      <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] text-white hover:bg-[#8A0408] px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-8528">
                        Find Out More
                      </a>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}